export const formatAccountName = (
  name: string,
  maskedAccountNumber: string,
): string => {
  return `${name} • ${maskedAccountNumber}`;
};
